import React from 'react';
import type { PublisherConfig } from '../../types/selfService';
import PublicHeader from './PublicHeader';

interface SelfServiceLayoutProps {
  config: PublisherConfig;
  children: React.ReactNode;
}

const SelfServiceLayout: React.FC<SelfServiceLayoutProps> = ({ config, children }) => {
  React.useEffect(() => {
    if (!config.fontUrl) return;
    const existingLink = document.querySelector(`link[href="${config.fontUrl}"]`);
    if (existingLink) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = config.fontUrl;
    document.head.appendChild(link);
    return () => { link.remove(); };
  }, [config.fontUrl]);

  return (
    <div
      className="min-h-screen bg-white flex flex-col"
      style={{ fontFamily: config.fontFamily }}
    >
      <PublicHeader publisher={config} />

      <main className="flex-1 py-4 overflow-x-clip">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default SelfServiceLayout;
